import { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { addNotification, markNotificationsRead, setAlertById, setNotificationStatus } from 'store/slices/AlertSlice'
import useAuthenticatedSocket from 'hooks/useAuthenticatedSocket'
import Notification from 'utils/Notifications'

const normalize = item => ({ ...item, ssylca: item.link || item.ssylca || '', alerts: item.message, surname_name: item.sender_name, image: item.sender_avatar, date_alerts: item.created_at })
const HandleWsNotifications = ({ user_id }) => {
  const dispatch = useDispatch()
  const seen = useRef(new Set())
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'info' })
  const { send, status } = useAuthenticatedSocket('/ws/me/notifications/', {
    enabled: Boolean(user_id),
    onOpen: socket => socket.send(JSON.stringify({ command: 'fetch_notifications' })),
    onMessage: data => {
      if (Array.isArray(data.notifications)) {
        seen.current = new Set(data.notifications.map(item => item.id))
        dispatch(setAlertById({ alerts: data.notifications.map(normalize) }))
      } else if (data.type === 'marked') {
        dispatch(markNotificationsRead(data.ids))
      } else if (data.type === 'notification') {
        const item = normalize(data.payload)
        dispatch(addNotification(item))
        if (!seen.current.has(item.id)) setNotify({ isOpen: true, message: item.message, type: 'info' })
        seen.current.add(item.id)
      }
    },
  })
  useEffect(() => { dispatch(setNotificationStatus(status)) }, [status, dispatch])
  useEffect(() => {
    const read = event => { if (Array.isArray(event.detail)) send({ command: 'mark_read', ids: event.detail }) }
    window.addEventListener('chu:notifications-read', read)
    return () => window.removeEventListener('chu:notifications-read', read)
  }, [send])
  return <Notification notify={notify} setNotify={setNotify} />
}
export default HandleWsNotifications
